import {
  ARTICLE_FULL_WIDTH_PAGE_TYPE,
  ARTICLE_RIGHT_RAIL_PAGE_TYPE,
  ARTICLE_SLIDESHOW_PAGE_TYPE,
  ARTICLE_CUSTOM_PAGE_TYPE,
  CHANNEL_PAGE_TYPE,
  VIDEO_SERIES_PAGE_TYPE
} from '../constants';

const DASH_BASE_URL = 'https://dash-wp.';

const getHostname = ({ hostname }) => {
  if (hostname === 'www-uat.qa.rf29.net') {
    return 'https://uat.dash-wp.rf29.net';
  }

  return DASH_BASE_URL + hostname.replace(/^(www|preview)\./, '');
};

const getDashPath = (id, type) => {
  const postTypePagePath = `/wp-admin/post.php?post=${id}&action=edit`;

  switch (type) {
    case ARTICLE_FULL_WIDTH_PAGE_TYPE:
    case ARTICLE_RIGHT_RAIL_PAGE_TYPE:
    case ARTICLE_SLIDESHOW_PAGE_TYPE:
    case ARTICLE_CUSTOM_PAGE_TYPE:
    case VIDEO_SERIES_PAGE_TYPE:
    case CHANNEL_PAGE_TYPE:
      return postTypePagePath;
    default:
      return null;
  }
};

export function getDashUrl(id, type, location) {
  const path = getDashPath(id, type);
  return (id && path)
    ? getHostname(location) + path
    : null;
}
